import * as React from 'react';
// components
import StyleProvider from 'modules/style-provider';
import AppTitle from 'components/app-title';
import AnalyticsProvider from 'modules/analytics-provider';
import LanguageBodyClass from 'modules/language-provider/language-body-class.component';
import ErrorBoundary from 'components/error-boundary';
import MetaDescription from 'modules/meta-description';
// types
import IConfig from '@sitegen/common/constants/config';

export interface IRootProps {
    config: IConfig;
}

export const RootComposer: React.FC<IRootProps> = (props): JSX.Element => (
    <ErrorBoundary>
        <AnalyticsProvider config={props.config}/>
        <MetaDescription />
        <StyleProvider styles={props.config.styles} widgetNames={[props.config.widgetName]}>
            <LanguageBodyClass/>
            <AppTitle/>
            {props.children}
        </StyleProvider>
    </ErrorBoundary>
);

RootComposer.displayName = 'RootComposer';

export default RootComposer;
